var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center mt-4"},[_c('router-link',{attrs:{"to":{name: 'patients'}}},[_c('button',{staticClass:"btn btn-primary round",attrs:{"type":"button"}},[_vm._v("444閉じる")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }